<template>
    <div class="body-container">
        <BannerSection
                       title="¿Necesitas préstamos personales urgentes? <br class='d-none d-lg-block'/>Así puedes conseguirlo " />
        <PerksComponent></PerksComponent>

        <div class="section-container regular-text">
            <div class="position-relative  pb-3 pb-md-0 ">
                <div class="text-container">
                    <h1 class=" titleh1"
                        ><b>Préstamo personal</b></h1>
                    <figure class="image-container">
                        <img :src="require(`@/assets/img/hombrePobre.png`)"
                             alt="persona haciendo calculos"
                             class="img-fluid">
                    </figure>
                    <p class="mb-0 regular-text">
                        ¿Necesitas dinero urgente pero no sabes por dónde empezar? Con un <b>préstamo personal</b>,
                        puedes obtener el dinero que necesitas para cualquier proyecto o emergencia.
                    </p>
                    <br>
                    <p class="regular-text">Este tipo de financiamiento ha sido diseñado para aquellos momentos en los que necesitas dinero
                        de forma rápida y eficiente. Aquí te explicamos cómo funcionan, sus beneficios, requisitos y
                        cómo puedes obtener uno.
                    </p>
                    <span class="regular-text">
                        <br>
                        <h2 class="h2-title"><b>Solicitud de préstamo personal online</b>
                        </h2>

                    </span>

                    <p class="regular-text">
                        Solicitar un <b>préstamo personal</b> nunca ha sido tan sencillo. En <b>Ibancar</b>, hemos
                        simplificado el proceso para que puedas hacerlo sin salir de casa y en pocos pasos.
                    </p>
                    <p class="regular-text">
                        Llena tu solicitud en línea proporcionando información básica y detalles de tu auto si decides
                        usarlo como respaldo. Utiliza nuestro simulador de préstamo personal para calcular cuánto puedes
                        recibir y ajustar las condiciones de pago a tus posibilidades.
                    </p>

                    <p class="regular-text">
                        Con nosotros, puedes conseguir un <b>préstamo con tu auto como garantía</b>, sin necesidad de
                        papeleo engorroso ni largas esperas.
                    </p>

                    <br>
                    <span class="regular-text">
                        <h2 class="h2-title"><b>¿Por qué elegir un préstamo personal en Ibancar?</b></h2>
                    </span>
                    <p class="regular-text">
                        Conseguir un préstamo personal en <b>Ibancar México</b> es rápido, seguro y diseñado para
                        adaptarse a
                        tus necesidades. Todo comienza con una solicitud sencilla que puedes completar en línea en pocos
                        minutos. <br> <br>
                        Luego de ingresar los datos de tu auto, te ofrecemos una propuesta de préstamo personalizada,
                        sin compromiso. El monto se determina según el valor de tu vehículo, que actúa como aval. No
                        importa tu historial en Buró de Crédito, en Ibancar tu auto es clave para obtener el
                        financiamiento que necesitas.<br> <br>
                        Si tienes dudas, nuestro equipo de soporte está disponible durante el horario comercial para
                        asesorarte y brindarte la información que necesites, ya sea por correo electrónico o vía
                        telefónica.<br> <br>
                        Una vez que aceptes la propuesta, solo necesitas aportar la documentación necesaria para
                        formalizar el acuerdo. En <b>menos de 24 horas</b>, el dinero será transferido a tu cuenta para
                        que
                        puedas usarlo como desees.<br> <br>
                        Las condiciones acordadas en el contrato incluirán mensualidades accesibles, abonos a capital
                        desde el primer pago y sin sorpresas finales. Además, tendrás acceso a un espacio personal en
                        nuestra plataforma, donde podrás consultar en cualquier momento el estado de tu préstamo, los
                        plazos y las amortizaciones.<br> <br>
                        En Ibancar, te brindamos soluciones financieras sin complicaciones, para que obtengas el dinero
                        que necesitas de manera rápida y confiable.
                    </p>

                    <br>
                </div>
            </div>
        </div>

        <div style="background-color: rgba(255, 165, 0, 0.04); padding: 1.5rem 0rem; margin: 1.5rem 0rem;">
            <div class="ibancar-election">
                <p>¿Por qué elegir Ibancar?</p>
            </div>
            <BeneficiosIbancarCarousel />
        </div>
        <div class="section-container regular-text">
            <div class="position-relative  pb-3 pb-md-0 ">
                <div class="text-container">
                    <br>
                    <span class="bold-text">
                        <br>
                        <h2 class="h2-title"><b>FAQs sobre el Préstamo personal</b></h2>
                        <br>
                    </span>
                    <div>
                        <p style="font-size: 23px; font-style: italic;" class="regular-text">- ¿Qué pasa si no puedo pagar un préstamo
                            personal?</p>
                        <p class="regular-text">Es importante que te comuniques con tu prestamista de inmediato para
                            buscar una solución. En <b>Ibancar</b>, entendemos que las situaciones pueden cambiar y
                            trabajamos contigo para encontrar alternativas como reestructurar los pagos. No dejes pasar
                            el problema; tomar acción rápida puede evitar mayores complicaciones.</p>
                    </div>
                    <br>
                    <div>
                        <p style="font-size: 23px; font-style: italic;" class="regular-text">- ¿Me pueden embargar si no pago un préstamo
                            personal?
                        </p>
                        <p class="regular-text">Si no cumples con tus pagos y no llegas a un acuerdo, el prestamista
                            puede tomar medidas legales para recuperar la deuda. En caso de haber usado tu auto como
                            garantía, este podría ser embargado. Por eso, es vital mantener una comunicación abierta y
                            evitar atrasos. </p>
                    </div>
                    <br>
                    <div>
                        <p style="font-size:23px; font-style: italic;" class="regular-text">- ¿Me pueden embargar mi casa por un préstamo
                            personal?</p>
                        <p class="regular-text">Un préstamo personal no está directamente vinculado a tu casa, pero
                            si no pagas, el prestamista podría recurrir a embargos en casos extremos. Sin embargo, con
                            un empeño de auto en México, tu casa no corre ningún riesgo, ya que el auto es la garantía
                            principal.
                            Con nuestro servicio, te garantizamos tranquilidad y eficiencia. ¡Solicita tu préstamo hoy y
                            resuelve tus necesidades financieras sin comprometer tu estabilidad!
                        </p>
                    </div>
                    <br>
                </div>

            </div>

        </div>
        <SolicitaloBannerS2 />
    </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import BannerSection from '@/components/Landings/BannerSection.vue';
import BeneficiosIbancarCarousel from '@/components/PrestamoGarantiaAuto/BeneficiosIbancarCarousel.vue';
import SolicitaloBannerS2 from '@/components/Landings/SolicitaloBannerS2.vue';
import PerksComponent from '../components/PerksComponent.vue';


export default {
    name: 'PrestamosPersonalesUrgentes',
    components: {
        BannerSection,
        BeneficiosIbancarCarousel,
        SolicitaloBannerS2,
        PerksComponent
    },
    setup() {
        useMeta(
            {
                title: 'Préstamos personales urgentes  | Ibancar',
                meta: [
                    {
                        name: 'robots',
                        content: 'index'
                    },
                    {
                        name: 'description',
                        content: 'Préstamos personales urgentes con tu coche como aval. Recibe efectivo rápido sin revisión de buró de crédito y con requisitos mínimos. ¡Solución inmediata!'
                    },
                    {
                        name: 'keywords',
                        content: 'prestamos personales urgentes'
                    }
                ],
                link: [
                    // { href: 'https://ibancar.com/prestamos-con-aval-de-coche-sin-cambiar-de-titular', rel: 'alternate', hreflang: 'es-es' },
                    { href: 'https://ibancar.mx/empeno-facil', rel: 'alternate', hreflang: 'es-MX' }
                ]
            }
        )
    },

    data() {
        return {
            ventajas: [
                {
                    image: 'image12.svg',
                    title: 'Ejecutivo personalizado',
                },
                {
                    image: 'solicitud-en-linea.svg',
                    title: 'Proceso simple sin salir de casa',
                },

                {
                    image: 'prestamos-48-hrs.svg',
                    title: 'Hasta $120,000 en 24H',
                },
                {
                    image: 'proceso-simple.svg',
                    title: 'Aceptamos personas en Buró.',
                }

            ]
        }
    }
}
</script>

<style scoped lang="scss">
@import 'bootstrap/scss/_functions.scss';
@import 'bootstrap/scss/_variables.scss';
@import 'bootstrap/scss/_mixins.scss';


.image-container {
    text-align: center;
    margin: 1.5rem 0rem;

    img {
        max-height: 400px;
    }
}

.body-container {
    margin-top: 4.5rem;
    min-height: calc(100vh - 115px);
}

@include media-breakpoint-up(md) {
    .body-container {
        margin-top: 8.5rem;
    }
}

.ibancar-election {
    margin: 1rem 2rem 0rem 2rem;

    p {
        color: #004680;
        text-align: center;
        font-family: 'Montserrat-Bold';
        font-size: 1.3rem;
        font-style: normal;
        line-height: normal;
        margin: 1.5rem 0rem;
    }
}

.text-container {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    font-size: 20px;
    text-align: justify;
}

.regular-text {
    font-family: "Montserrat";
    font-size: 20px;
    line-height: 30px;
}

.title {
    font-size: 25px;
    line-height: 30px;
}

.bold-text {
    font-family: "Montserrat-Bold";
}

.text-orange {
    color: $orange;
}

.text-blue {
    color: $blue;
}

.text-black {
    color: $black;
}

.text-underline {
    text-decoration: underline;
}

.btn-solicitar {
    a {
        &:hover {
            text-decoration: none;
        }
    }
}

// Image
.image {
    bottom: 0;
    right: 0;
    width: 30%;
    z-index: -1;
}

@include media-breakpoint-down(md) {
    .text-container {
        width: 90%;
    }

    .regular-text {
        line-height: 1.5;
    }

    ul {
        padding-inline-start: 20px;
    }

    ol {
        padding-inline-start: 20px;
    }

    p,
    h1,
    h2,
    h3,
    h4 {
        text-align: left;
    }
}

@include media-breakpoint-up(lg){
    figure {
        img {
            display: none;
        }
    }
}

@include media-breakpoint-between(md, lg) {
    .regular-text {
        font-size: 16px;
    }

    .title {
        font-size: 28px;
        line-height: 35px;
    }

    .subtitle {
        font-size: 16px;
    }
}

@include media-breakpoint-down(sm) {

    .titleh1 {
        font-size: 23px;
    }

    .h2-title {
        font-size: 19px;
        line-height: 20px;
    }

    .h3-title {
        font-size: 16px;
        line-height: 20px;
    }

    .subtitle {
        font-size: 16px;
        line-height: 20px;
    }

    .regular-text {
        font-size: 14px !important;
    }

    .section-container {
        margin-top: 1.5rem;
    }
}
</style>